import { render, staticRenderFns } from "./ChainsForm.vue?vue&type=template&id=950bb326&scoped=true&lang=pug&"
import script from "./ChainsForm.vue?vue&type=script&lang=js&"
export * from "./ChainsForm.vue?vue&type=script&lang=js&"
import style0 from "./ChainsForm.vue?vue&type=style&index=0&id=950bb326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950bb326",
  null
  
)

export default component.exports